export const ComponentType = {
  form: "form",
  input: "input",
  modal: "modal",
  list: "list",
  table: "table",
};
export const InputFieldType = {
  text: "text",
  password: "password",
  number: "number",
  email: "email",
  select: "select",
  checkbox: "checkbox",
  radio: "radio",
};
